const assetGroupControlsContainer = {
  width: '660px',
  marginRight: '40px',
};

export const getAssetGroupStepStyles = (components, theme) => ({
  collapsiblePanel: {
    border: 'none',
    marginBottom: 'unset',
    backgroundColor: 'unset',

    '& .panel-heading': {
      padding: 0,
      borderBottom: 'none',
      marginBottom: 18,

      '& .panel-title': {
        fontSize: 18,
        '& > a': {
          marginLeft: '-8px', // compensate 8px padding on the left of icon
          color: theme.palette.themePrimary,
          padding: 0,
          '&:hover, &:active': {
            color: theme.palette.themeDarker,
            textDecoration: 'none',
            backgroundColor: 'unset',
          },
        },

        '& > a:after': {
          transform: 'rotate(180deg)',
        },

        '& > a.collapsed:after': {
          transform: 'rotate(90deg)',
        },
      },
    },

    '& .panel-collapse': {
      '& .panel-body': {
        padding: 0,
        overflow: 'hidden',
      },
    },
  },

  h3LabelOptional: {
    fontSize: 14,
    color: theme.palette.neutralSecondary,
  },

  audienceSignalDescription: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    columnGap: 12,
    fontSize: 14,

    '& > img': {
      gridRow: '1 / 3',
    },

    '& .audience-signal-main-description': {
      fontWeight: 600,
    },

    '& .audience-signal-sub-description': {
      color: theme.palette.neutralSecondary,
    },
  },

  assetGroupSettingsContentContainer: {
    display: 'flex',
    flexDirection: 'column',

    '& .page-title': {
      marginBottom: '16px',
    },

    '& .page-description': {
      marginBottom: '32px',
    },

    '& .section-title': {
      marginTop: '28px',
      marginBottom: '8px',
    },

    '& .section-description': {
      marginBottom: '16px',
    },

    '& .asset-group-controls-container': {
      ...assetGroupControlsContainer,
    },

    '& .asset-group-controls-with-preview-container':
    {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',

      '& .controls-affecting-preview-container': {
        ...assetGroupControlsContainer,
      },

      '& .asset-group-preview-container': {
        marginTop: '41px',
        position: 'sticky',
        top: '0px',
      },
    },
  },
  audienceWizard: {
    marginTop: 24,
  },
});

